import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconDeleteComponent } from "./med-icon-delete.component";

@NgModule({
  declarations: [
    MedIconDeleteComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconDeleteComponent,
  ],
})
export class MedIconDeleteModule { }
